import { render, staticRenderFns } from "./GBDayWeekDay.vue?vue&type=template&id=a658dd02&"
import script from "./GBDayWeekDay.vue?vue&type=script&lang=js&"
export * from "./GBDayWeekDay.vue?vue&type=script&lang=js&"
import style0 from "./GBDayWeekDay.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/ganttboard/project/ganttboard-frontend/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib'
installComponents(component, {VTooltip})
